/* General utility functions
*  Can be used anywhere
*/

//Adds an element to an array only if the array does not already contain the element
export const addToArrNoDupe = (arr, val) => {
  if (arr.indexOf(val) === -1) {
    return [...arr, val];
  }
  return arr;
};

//Removes the element from the array if it finds it
export const removeFromArr = (arr, val) => {
  let index = arr.indexOf(val);
  if (index !== -1) {
    return [
      ...arr.slice(0, index),
      ...arr.slice(index + 1),
    ];
  }
  return arr;
};

export const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];
export const weekday = [
  "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday",
];

//Returns a date string in the format: Weekday, DD Month YYYY
export const getFullDate = (date) => {
  return weekday[date.getDay()] + ", " + date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
};

export const getWeekdayFromDate = (date) => {
  return weekday[date.getDay()];
};

//Returns a date string in the format: DD Month YYYY
export const getDateNoWeekday = (date) => {
  return date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
};

//Returns a date string in the format: DD Month YYYY hh:mm
export const getDateAndTime = (date) => {
  let h = date.getHours();
  let m = date.getMinutes();
  if (h < 10) {
    h = "0" + h;
  }
  if (m < 10) {
    m = "0" + m;
  }
  return date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear() + " " + h + ":" + m;
};

//Transforms number into formatted price (label optional)
export const formatPrice = (num, label = null, currencyLabel="R") => {
  //Remove minus if num is negative
  if (num < 0) {
    num = num * -1;
    currencyLabel = "-" + currencyLabel;
  }

  let x = num.toFixed(2).split(".");
  //x1 is the integer part
  let x1 = x[0];
  let x2 = "";
  
  if (Number(x[1]) !== 0) {
    x2 = "." + x[1]; //Place decimals in x2
  }

  //Add commas for long numbers (every third integer - e.g. R100,000)
  const rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + "," + "$2");
  }
  num = currencyLabel + x1 + x2;
  return label ? [num, label].join(" ") : num;
};

//Will not trigger the callback until it hasn't been called at least 'wait' milliseconds
export const debounce = (callback, wait, debounceStart=null) => {
  let timeoutId = null;
  return (...args) => {
    if ((timeoutId === null) && (debounceStart !== null)) {
      debounceStart();
    }
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
      timeoutId = null;
    }, wait);
  };
};

export const throttle = (callback, limit) => {
  let waiting = false;
  return (...args) => {
    if (!waiting) {
      callback.apply(null, args);
      waiting = true;
      setTimeout(() => {
        waiting = false;
      }, limit);
    }
  };
};
